import {jwtDecode} from "jwt-decode";

export async function  getCurrentSessionExpireTime(): Promise<number> {
  const token = getLocalStorageKey('accessToken');
  return token && jwtDecode<any>(token)['exp']
    ? Number.parseInt(jwtDecode<any>(token)['exp'].toString() + '000', 0)
    : 0;
}

export function getLocalStorageKey(name: string): string {
  return (
    window.localStorage.getItem(Object.keys(window.localStorage).find((x) => x.includes(name)) || '') || ''
  );
}
